export enum Role {
  All = "All",
  Admin = "Admin",
  Doctor = "Doctor",
  Patient = "Patient",
  Hospital = "Hospital",
  Pharmacy = "medical_store",
  Drugstore= "drug_store"
}
